
import { defineComponent, onMounted, ref } from 'vue';
import { useJokesStore } from '@/core/store/jokes/useJokesStore';
import { storeToRefs } from 'pinia';
import PuzzleImg from '@/assets/img/puzzle.png';
import { JokeInterface } from '@/core/models/interfaces/joke.interface';

export default defineComponent({
	data() {
		return {
			puzzleSrc: PuzzleImg,
			isShowClue: false
		};
	},
	setup() {
		const jokesStore = useJokesStore();

		const { data, isLoading, filters } = storeToRefs(jokesStore);

		const jokeText = ref('');
		const jokeClue = ref('');
		const isJokeHasClue = ref(false);

		onMounted(async () => {
			await jokesStore.getData();

			if (data.value) {
				setJokeData(data.value);
			}
		});

		function setJokeData(data: JokeInterface) {
			if (data) {
				if (data && data.setup && data.delivery) {
					jokeText.value = data.setup;

					jokeClue.value = data.delivery;
					isJokeHasClue.value = true;
				} else if (data?.joke) {
					jokeText.value = data.joke;

					jokeClue.value = '';
					isJokeHasClue.value = false;
				}
			}
		}

		return {
			jokeText,
			jokeClue,
			isLoading,
			isJokeHasClue,
			data,
			setJokeData,
			jokesStore
		};
	},
	methods: {
		handleShowClue(state: boolean) {
			this.isShowClue = state;
		},
		async getNewJoke() {
			this.handleShowClue(false);
			await this.jokesStore.getData();
		}
	},
	watch: {
		data: {
			handler(updatedData) {
				this.setJokeData(updatedData);
			},
			deep: true
		}
	}
});
